import { ConfigStore } from "../config/config";


export function defineOfficeDocumentConfigStore<T>(key:string):ConfigStore<T> {
    return {
        load: async () => {
            return Office.context.document.settings.get(key);
        },
        save: async (config?: T) => {
            if (config === undefined) Office.context.document.settings.remove(key);
            else Office.context.document.settings.set(key, config);

            void Office.context.document.settings.saveAsync();
        }
    }
}